import $ from 'jquery';
import busyGif from 'images/busy.gif';

$(document).ready(() => {
  // Show busy gif on click to vote (excluding proxy vote which opens modal)
  $(document).rebind('click.vote', '.idea-endorsement a', event => {
    if (
      $(event.target).closest('.proxy-vote, .dropdown-vote__proxy-vote')
        .length === 0
    )
      // This pattern is discouraged but safe in this case because busyGif is static.
      // eslint-disable-next-line no-unsanitized/method
      $(event.target)
        .closest('.idea-endorsement')
        .find('.vote-status')
        .html(`<img src=${busyGif} />`);
  });
});
